import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  div {
    display: flex;
    justify-content: flex-end;

    width: 100%;
    color: ${props => props.theme.colors.grey2};

    button {
      display: flex;
      justify-content: center;
      align-items: center;

      background: transparent;
      border: none;
    }
  }

  h1 {
    color: ${props => props.theme.colors.grey};
    font-weight: bold;
    font-family: Raleway;
    font-size: 30px;
    font-weight: 600;
    line-height: 39px;
    letter-spacing: 0px;
    text-align: center;

    margin: 30px 0px 10px 0px;
  }

  p {
    font-family: Raleway;
    font-size: 18px;
    font-weight: 500;
    line-height: 23px;
    letter-spacing: 0px;
    text-align: center;
    color: ${props => props.theme.colors.grey1};

    & + p {
      margin-top: 30px;
    }
  }

  > button {
    max-width: 250px;
    margin-top: 30px;
  }
`;
